var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ArrowDownOutlined } from '@feb-team/legao-icons-react';
import DropdownItem from './DropdownItem';
import GroupItem from './GroupItem';
import { DropdownBaseCls, DropdownBorderedCls } from './clsMap';
import { defaultDropdownProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        /**
         * 获取容器绑定 clickoutside
         * @param ref
         */
        _this.getContainer = function (ref) {
            _this.container = ref;
        };
        /**
         * hover 触发显示 下拉列表
         */
        _this.showItems = function () {
            var disabled = _this.props.disabled;
            if (!disabled) {
                _this.setState({ visible: true });
            }
        };
        /**
         * hover 触发隐藏 下拉列表
         */
        _this.hideItems = function () {
            _this.setState({ visible: false });
        };
        /**
         * 打开下拉菜单
         */
        _this.handleClick = function () {
            var disabled = _this.props.disabled;
            if (!disabled) {
                _this.setState({ visible: !_this.state.visible });
            }
        };
        /**
         * click 触发点击其他区域隐藏 下拉列表
         */
        _this.handleClickOutside = function (e) {
            // 拿到容器判断，当前点击包含在容器内，执行 clickOutSide
            var el = _this.container;
            // 防止同一个页面使用多个 dropdown 组件，导致点击 document 互相影响。
            if (!el.contains(e.target)) {
                if (e.nativeEvent) {
                    e.nativeEvent.stopImmediatePropagation();
                }
                if (_this.state.visible) {
                    _this.setState({ visible: false });
                }
            }
        };
        /**
         * 选中下拉选项后执行函数
         * @param clickItemProps 选中下拉项组件 props
         */
        _this.handleDropdownItemClick = function (clickItemProps, e) {
            _this.setState({
                visible: false,
            });
            if (_this.props.onItemSelect) {
                _this.props.onItemSelect(clickItemProps, e);
            }
        };
        _this.renderChildren = function (children) {
            if (!children) {
                return null;
            }
            return React.Children.map(children, function (child, index) {
                if (!child) {
                    return null;
                }
                else if (typeof child === 'string') {
                    return child;
                }
                else {
                    var childKey = child.key;
                    var childCls = child.props ? child.props.className : '';
                    var attribute = {
                        key: childKey ? childKey : "item-" + index,
                        onItemSelect: _this.handleDropdownItemClick,
                        className: childCls,
                    };
                    return React.cloneElement(child, attribute);
                }
            });
        };
        _this.renderList = function () {
            var children = _this.props.children;
            var visible = _this.state.visible;
            var List;
            if (visible && children) {
                var listHtml = _this.renderChildren(children);
                List = (React.createElement(DivTag, { atomics: ['relative', 'z-10'], className: "legao-dropdown-list" }, listHtml));
                return (React.createElement(DivTag, { atomics: ['z-50', 'absolute'], className: "legao-dropdown-bd-content" },
                    React.createElement(DivTag, { atomics: ['bg-white', 'min-w-px-160', 'max-w-px-200', 'rounded-md'], className: "legao-dropdown-bd" }, List)));
            }
            return null;
        };
        _this.state = {
            visible: false,
            title: props.title,
        };
        return _this;
    }
    Dropdown.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.title !== this.props.title) {
            this.setState({
                title: nextProps.title,
            });
        }
    };
    Dropdown.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside);
    };
    Dropdown.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside);
    };
    Dropdown.prototype.render = function () {
        var _a = this.props, triggerEvent = _a.triggerEvent, style = _a.style, bordered = _a.bordered, className = _a.className, rest = __rest(_a, ["triggerEvent", "style", "bordered", "className"]);
        var cls = DropdownBaseCls;
        if (bordered) {
            cls = cls.concat(DropdownBorderedCls);
        }
        var List = this.renderList();
        var title = this.state.title;
        return (React.createElement(DivTag, __assign({ name: Dropdown.NAME, atomics: ['inline-block', 'relative'], ref: this.getContainer, onMouseEnter: triggerEvent && triggerEvent === 'mouseover' ? this.showItems : function () { return null; }, onMouseLeave: triggerEvent && triggerEvent === 'mouseover' ? this.hideItems : function () { return null; }, style: style, className: className }, rest, { title: "" }),
            React.createElement(DivTag, { role: "button", atomics: cls, onClick: triggerEvent && triggerEvent === 'click' ? this.handleClick : function () { return null; }, onKeyPress: triggerEvent && triggerEvent === 'click' ? this.handleClick : function () { return null; } },
                React.createElement("span", null, title),
                React.createElement(ArrowDownOutlined, { className: "ml-px-5" })),
            List));
    };
    Dropdown.Item = DropdownItem;
    Dropdown.GroupItem = GroupItem;
    Dropdown.defaultProps = defaultDropdownProps;
    Dropdown.NAME = 'dropdown';
    Dropdown.displayName = 'Dropdown';
    return Dropdown;
}(React.PureComponent));
export { Dropdown };
